import { render, staticRenderFns } from "./AccountingAccountsAffectation.vue?vue&type=template&id=b5628a34&"
import script from "./AccountingAccountsAffectation.vue?vue&type=script&lang=js&"
export * from "./AccountingAccountsAffectation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports